import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Avatar } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),

      display: "flex",
      flexDirection: "column",
    },
  },
}));

export default function Profile() {
  const classes = useStyles();

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <div className="d-flex align-items-center w-100 ">
        <Avatar style={{ height: "10rem", width: "10rem" }}>H</Avatar>
      </div>
      <TextField id="outlined-basic" label="First Name" variant="outlined" />
      <TextField id="outlined-basic" label="Last Name" variant="outlined" />
      <TextField id="outlined-basic" label="email" variant="outlined" />
      <TextField id="outlined-basic" label="password" variant="outlined" />
    </form>
  );
}
